// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paysendCardV1-module_paysendCardContainer__T0Juk {
    min-width: 249px;
}

.paysendCardV1-module_cardContainer__ZRvVW {
    position: relative;
    overflow: hidden;
    padding: 12px 12px 10px 12px;
    background: var(--purple_100);
    aspect-ratio: 1.6;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 12px;
    cursor: pointer;
    margin: 0 auto;
    width: 249px;

    &:active {
        background: var(--purple_72_tr);
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--purple_72_tr);
        }
    }

    @media screen and (min-width: 392px) {
        max-width: 360px;
    }

    &::before {
        display: none;
    }
}

.paysendCardV1-module_cardAnimationZoomOut__nv1oq {
    animation: paysendCardV1-module_CardZoomOut__OcAVo 0.3s forwards;
}

.paysendCardV1-module_topLayoutOnCardScreen__qUGIQ .paysendCardV1-module_cardAnimationZoomIn__TFoG8 {
    animation: paysendCardV1-module_CardZoomIn__s3hDH 0.3s forwards;
}

.paysendCardV1-module_cardContainer__ZRvVW.paysendCardV1-module_frozen___kz9h {
    background: var(--frozen-background-image) no-repeat center center / cover var(--purple_100);
}

.paysendCardV1-module_cardContainer__ZRvVW.paysendCardV1-module_expired__rjcJo {
    background: var(--expired-background-image) no-repeat center center / cover var(--purple_100);
}

.paysendCardV1-module_cardContainer__ZRvVW.paysendCardV1-module_firstRender__I3ut6 {
    animation: none;
}

.paysendCardV1-module_cardContainer__ZRvVW.paysendCardV1-module_cardContainerOnCardScreen__HS1LW {
    padding: 24px;
    cursor: default;

    &:active {
        background: var(--purple_100);
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--purple_100);
        }
    }

    @media screen and (min-width: 392px) {
        width: 100%;
    }
}

.paysendCardV1-module_cardContainer__ZRvVW.paysendCardV1-module_cardContainerInactive__sJYxV {
    &::before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(at center, var(--purple_100), var(--purple_0_tr_base));
    }
}

.paysendCardV1-module_cardRow__Drw2X {
    display: flex;
    align-items: center;
}

.paysendCardV1-module_cardRow__Drw2X.paysendCardV1-module_spaceBetween__f73_L {
    justify-content: space-between;
}

.paysendCardV1-module_cardRow__Drw2X.paysendCardV1-module_topAlignment__lJwKG {
    align-items: start;
}

.paysendCardV1-module_psIconContainer__wWVEp {
    svg {
        max-width: 100%;
        max-height: 100%;
    }
}

.paysendCardV1-module_psIconContainer__wWVEp.paysendCardV1-module_psIconContainerInactive__PrdYN {
    opacity: 0.48;
}

.paysendCardV1-module_tagContainer__VEgIU {
    display: inline-flex;
    position: relative;
}

.paysendCardV1-module_paymentIconsRow__qCuT5 {
    display: flex;
    column-gap: 10px;
}

.paysendCardV1-module_paymentIconsRow__qCuT5.paysendCardV1-module_paymentIconsRowCardScreen__fiQVN {
    column-gap: 20px;
}

.paysendCardV1-module_iconContainer__k2Olg {
    svg {
        max-width: 100%;
    }
}

.paysendCardV1-module_cardScreen__JrREU {
    position: fixed;
    width: 100%;
    height: 100%;
    flex-direction: column;
    display: flex;
    z-index: -1;
    opacity: 0;
    background: var(--grey_8_lc);
}

.paysendCardV1-module_cardScreen__JrREU.paysendCardV1-module_cardScreenOnCardScreen___zaVE {
    z-index: var(--zindex-modal-index);
    opacity: 1;
}

.paysendCardV1-module_layoutContainer__IDDw5 {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.paysendCardV1-module_topLayout__Euxuj {
    background: transparent;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 64px 16px 16px 16px;
    background: var(--grey_8_lc);

    @media screen and (max-height: 634px) {
        padding: 24px 16px 16px 16px;
    }
}

.paysendCardV1-module_layoutInner__g6jjX {
    width: 100%;
    max-width: 448px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
}

.paysendCardV1-module_textContainer__Ec2LX {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;

    @media screen and (max-height: 634px) {
        flex: 0;
    }
}

.paysendCardV1-module_bottomLayout__F6oSF {
    background: var(--white);
    padding: 0 16px 29px 16px;
    position: relative;
    animation: paysendCardV1-module_BottomSlideOut__HDZf3 0.3s forwards;
}

.paysendCardV1-module_bottomLayout__F6oSF.paysendCardV1-module_bottomLayoutCardScreen__hPgKX {
    animation: paysendCardV1-module_BottomSlideIn__hqDWz 0.3s forwards;
}

.paysendCardV1-module_cardBalanceButtons__Glvpk {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    margin-bottom: 24px;
}

.paysendCardV1-module_cardBalanceButtons__Glvpk.paysendCardV1-module_cardBalanceButtonsHasButtonRow__SDiUt {
    margin-left: -24px;
    margin-right: -24px;
}

.paysendCardV1-module_copyButton__iKf2W {
    padding: 16px 24px;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--purple_16_tr);
        }
    }

    &:active,
    &:focus-visible {
        background: var(--purple_8_tr);
    }
}

.paysendCardV1-module_copyButtonIcon__OdhUL {
    margin-left: 8px;
    flex-shrink: 0;
}

.paysendCardV1-module_addWalletButton__uhbYc {
    padding: 0;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
    margin-top: 24px;
}

.paysendCardV1-module_cardBalanceDone__zJ_zg {
    display: flex;
    justify-content: center;
}

@keyframes paysendCardV1-module_CardZoomIn__s3hDH {
    0% {
        width: 249px;
    }
    100% {
        width: 361px;
    }
}

@keyframes paysendCardV1-module_CardZoomOut__OcAVo {
    0% {
        width: 361px;
    }
    100% {
        width: 249px;
    }
}

@keyframes paysendCardV1-module_BottomSlideIn__hqDWz {
    0% {
        bottom: -100%;
    }
    100% {
        bottom: 0;
    }
}

@keyframes paysendCardV1-module_BottomSlideOut__HDZf3 {
    0% {
        bottom: 0;
    }
    100% {
        bottom: -100%;
    }
}

@keyframes paysendCardV1-module_HideCardScreen__Iu5pP {
    0% {
        z-index: 1;
        opacity: 1;
        background: var(--grey_8_lc);
    }
    90% {
        z-index: 1;
        /*opacity: 1;*/
        background: var(--grey_8_lc);
    }
    100% {
        z-index: -1;
        opacity: 0;
        background: transparent;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Card/CardBalance/paysendCardV1.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;;IAEZ;QACI,+BAA+B;IACnC;;IAEA;QACI;YACI,+BAA+B;QACnC;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gEAAoC;AACxC;;AAEA;IACI,+DAAmC;AACvC;;AAEA;IACI,4FAA4F;AAChG;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;;IAEf;QACI,6BAA6B;IACjC;;IAEA;QACI;YACI,6BAA6B;QACjC;IACJ;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,kFAAkF;IACtF;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,4BAA4B;IAC5B,4BAA4B;;IAE5B;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,OAAO;IACX;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mEAAuC;AAC3C;;AAEA;IACI,kEAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B;QACI;YACI,+BAA+B;QACnC;IACJ;;IAEA;;QAEI,8BAA8B;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;IAC3B;AACJ","sourcesContent":[".paysendCardContainer {\n    min-width: 249px;\n}\n\n.cardContainer {\n    position: relative;\n    overflow: hidden;\n    padding: 12px 12px 10px 12px;\n    background: var(--purple_100);\n    aspect-ratio: 1.6;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    box-sizing: border-box;\n    border-radius: 12px;\n    cursor: pointer;\n    margin: 0 auto;\n    width: 249px;\n\n    &:active {\n        background: var(--purple_72_tr);\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--purple_72_tr);\n        }\n    }\n\n    @media screen and (min-width: 392px) {\n        max-width: 360px;\n    }\n\n    &::before {\n        display: none;\n    }\n}\n\n.cardAnimationZoomOut {\n    animation: CardZoomOut 0.3s forwards;\n}\n\n.topLayoutOnCardScreen .cardAnimationZoomIn {\n    animation: CardZoomIn 0.3s forwards;\n}\n\n.cardContainer.frozen {\n    background: var(--frozen-background-image) no-repeat center center / cover var(--purple_100);\n}\n\n.cardContainer.expired {\n    background: var(--expired-background-image) no-repeat center center / cover var(--purple_100);\n}\n\n.cardContainer.firstRender {\n    animation: none;\n}\n\n.cardContainer.cardContainerOnCardScreen {\n    padding: 24px;\n    cursor: default;\n\n    &:active {\n        background: var(--purple_100);\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--purple_100);\n        }\n    }\n\n    @media screen and (min-width: 392px) {\n        width: 100%;\n    }\n}\n\n.cardContainer.cardContainerInactive {\n    &::before {\n        display: block;\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: radial-gradient(at center, var(--purple_100), var(--purple_0_tr_base));\n    }\n}\n\n.cardRow {\n    display: flex;\n    align-items: center;\n}\n\n.cardRow.spaceBetween {\n    justify-content: space-between;\n}\n\n.cardRow.topAlignment {\n    align-items: start;\n}\n\n.psIconContainer {\n    svg {\n        max-width: 100%;\n        max-height: 100%;\n    }\n}\n\n.psIconContainer.psIconContainerInactive {\n    opacity: 0.48;\n}\n\n.tagContainer {\n    display: inline-flex;\n    position: relative;\n}\n\n.paymentIconsRow {\n    display: flex;\n    column-gap: 10px;\n}\n\n.paymentIconsRow.paymentIconsRowCardScreen {\n    column-gap: 20px;\n}\n\n.iconContainer {\n    svg {\n        max-width: 100%;\n    }\n}\n\n.cardScreen {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    display: flex;\n    z-index: -1;\n    opacity: 0;\n    background: var(--grey_8_lc);\n}\n\n.cardScreen.cardScreenOnCardScreen {\n    z-index: var(--zindex-modal-index);\n    opacity: 1;\n}\n\n.layoutContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.topLayout {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    padding: 64px 16px 16px 16px;\n    background: var(--grey_8_lc);\n\n    @media screen and (max-height: 634px) {\n        padding: 24px 16px 16px 16px;\n    }\n}\n\n.layoutInner {\n    width: 100%;\n    max-width: 448px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n}\n\n.textContainer {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n\n    @media screen and (max-height: 634px) {\n        flex: 0;\n    }\n}\n\n.bottomLayout {\n    background: var(--white);\n    padding: 0 16px 29px 16px;\n    position: relative;\n    animation: BottomSlideOut 0.3s forwards;\n}\n\n.bottomLayout.bottomLayoutCardScreen {\n    animation: BottomSlideIn 0.3s forwards;\n}\n\n.cardBalanceButtons {\n    display: flex;\n    justify-content: center;\n    margin-top: 8px;\n    margin-bottom: 24px;\n}\n\n.cardBalanceButtons.cardBalanceButtonsHasButtonRow {\n    margin-left: -24px;\n    margin-right: -24px;\n}\n\n.copyButton {\n    padding: 16px 24px;\n    border: none;\n    background: none;\n    outline: none;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--purple_16_tr);\n        }\n    }\n\n    &:active,\n    &:focus-visible {\n        background: var(--purple_8_tr);\n    }\n}\n\n.copyButtonIcon {\n    margin-left: 8px;\n    flex-shrink: 0;\n}\n\n.addWalletButton {\n    padding: 0;\n    border: none;\n    background: none;\n    outline: none;\n    cursor: pointer;\n    margin-top: 24px;\n}\n\n.cardBalanceDone {\n    display: flex;\n    justify-content: center;\n}\n\n@keyframes CardZoomIn {\n    0% {\n        width: 249px;\n    }\n    100% {\n        width: 361px;\n    }\n}\n\n@keyframes CardZoomOut {\n    0% {\n        width: 361px;\n    }\n    100% {\n        width: 249px;\n    }\n}\n\n@keyframes BottomSlideIn {\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n}\n\n@keyframes BottomSlideOut {\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n}\n\n@keyframes HideCardScreen {\n    0% {\n        z-index: 1;\n        opacity: 1;\n        background: var(--grey_8_lc);\n    }\n    90% {\n        z-index: 1;\n        /*opacity: 1;*/\n        background: var(--grey_8_lc);\n    }\n    100% {\n        z-index: -1;\n        opacity: 0;\n        background: transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paysendCardContainer": `paysendCardV1-module_paysendCardContainer__T0Juk`,
	"cardContainer": `paysendCardV1-module_cardContainer__ZRvVW`,
	"cardAnimationZoomOut": `paysendCardV1-module_cardAnimationZoomOut__nv1oq`,
	"CardZoomOut": `paysendCardV1-module_CardZoomOut__OcAVo`,
	"topLayoutOnCardScreen": `paysendCardV1-module_topLayoutOnCardScreen__qUGIQ`,
	"cardAnimationZoomIn": `paysendCardV1-module_cardAnimationZoomIn__TFoG8`,
	"CardZoomIn": `paysendCardV1-module_CardZoomIn__s3hDH`,
	"frozen": `paysendCardV1-module_frozen___kz9h`,
	"expired": `paysendCardV1-module_expired__rjcJo`,
	"firstRender": `paysendCardV1-module_firstRender__I3ut6`,
	"cardContainerOnCardScreen": `paysendCardV1-module_cardContainerOnCardScreen__HS1LW`,
	"cardContainerInactive": `paysendCardV1-module_cardContainerInactive__sJYxV`,
	"cardRow": `paysendCardV1-module_cardRow__Drw2X`,
	"spaceBetween": `paysendCardV1-module_spaceBetween__f73_L`,
	"topAlignment": `paysendCardV1-module_topAlignment__lJwKG`,
	"psIconContainer": `paysendCardV1-module_psIconContainer__wWVEp`,
	"psIconContainerInactive": `paysendCardV1-module_psIconContainerInactive__PrdYN`,
	"tagContainer": `paysendCardV1-module_tagContainer__VEgIU`,
	"paymentIconsRow": `paysendCardV1-module_paymentIconsRow__qCuT5`,
	"paymentIconsRowCardScreen": `paysendCardV1-module_paymentIconsRowCardScreen__fiQVN`,
	"iconContainer": `paysendCardV1-module_iconContainer__k2Olg`,
	"cardScreen": `paysendCardV1-module_cardScreen__JrREU`,
	"cardScreenOnCardScreen": `paysendCardV1-module_cardScreenOnCardScreen___zaVE`,
	"layoutContainer": `paysendCardV1-module_layoutContainer__IDDw5`,
	"topLayout": `paysendCardV1-module_topLayout__Euxuj`,
	"layoutInner": `paysendCardV1-module_layoutInner__g6jjX`,
	"textContainer": `paysendCardV1-module_textContainer__Ec2LX`,
	"bottomLayout": `paysendCardV1-module_bottomLayout__F6oSF`,
	"BottomSlideOut": `paysendCardV1-module_BottomSlideOut__HDZf3`,
	"bottomLayoutCardScreen": `paysendCardV1-module_bottomLayoutCardScreen__hPgKX`,
	"BottomSlideIn": `paysendCardV1-module_BottomSlideIn__hqDWz`,
	"cardBalanceButtons": `paysendCardV1-module_cardBalanceButtons__Glvpk`,
	"cardBalanceButtonsHasButtonRow": `paysendCardV1-module_cardBalanceButtonsHasButtonRow__SDiUt`,
	"copyButton": `paysendCardV1-module_copyButton__iKf2W`,
	"copyButtonIcon": `paysendCardV1-module_copyButtonIcon__OdhUL`,
	"addWalletButton": `paysendCardV1-module_addWalletButton__uhbYc`,
	"cardBalanceDone": `paysendCardV1-module_cardBalanceDone__zJ_zg`,
	"HideCardScreen": `paysendCardV1-module_HideCardScreen__Iu5pP`
};
export default ___CSS_LOADER_EXPORT___;
